export default __webpack_public_path__ + "static/media/math.3176d25f.png";